import React from "react";

import { useAssociationSettings } from "./hooks/useAssociationSettings";

import AssociationHeader from "./components/AssociationHeader";
import AssociationKpiCards from "./components/AssociationKpiCards";
import AssociationForm from "./components/AssociationForm";
import LogoUploadDrawer from "./components/LogoUploadDrawer";

export default function SettingsAssociation() {
  const dashboard = useAssociationSettings();

  const formId = "association-settings-form";

  return (
    <div className="space-y-5">
      <AssociationHeader
        formId={formId}
        saving={dashboard.saving}
        loading={dashboard.loading}
      />

      {/* <AssociationKpiCards
        stats={dashboard.stats}
        loading={dashboard.loading}
      /> */}

      <AssociationForm
        formId={formId}
        settings={dashboard.settings}
        loading={dashboard.loading}
        saving={dashboard.saving}
        logoSrc={dashboard.logoSrc}
        seasonOptions={dashboard.seasonOptions}
        onChange={dashboard.handleChange}
        onSubmit={dashboard.saveSettings}
        onOpenLogoUpload={dashboard.openLogoDrawer}
      />

      <LogoUploadDrawer
        isOpen={dashboard.logoDrawerOpen}
        uploading={dashboard.uploadingLogo}
        uploadProgress={dashboard.uploadProgress}
        currentLogoSrc={dashboard.logoSrc}
        clubName={dashboard.settings.nom_club}
        onClose={dashboard.closeLogoDrawer}
        onSubmit={dashboard.handleUploadLogo}
      />
    </div>
  );
}